import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_389: DocMigration = {
  maxSchemaVersion: "0.0.389",
  description: "Change wall visibility settings",
  apply(json: any) {
    for (const id in json["view3Ds"]) {
      const view = json["view3Ds"][id];
      const { viewFilter } = view;
      json["view3Ds"][id] = {
        ...view,
        viewFilter: migrateViewFilter(viewFilter),
      };
    }
    for (const id in json["planViews"]) {
      const view = json["planViews"][id];
      const { viewFilter } = view;
      json["planViews"][id] = {
        ...view,
        viewFilter: migrateViewFilter(viewFilter),
      };
    }

    return json;
  },
};

function migrateViewFilter(vf: any): any {
  const newVf = { ...vf };

  if (vf.walls !== undefined) {
    newVf.wallCore = vf.walls;
  }

  if (vf.wallAssemblies !== undefined) {
    newVf.wallSubstrate = vf.wallAssemblies;
    newVf.wallExteriorFinish = vf.wallAssemblies;
    delete newVf.wallAssemblies;
  }

  return newVf;
}

export default migration_0_0_389;
